<template>
  <span class="edit-label edit-field">
      <input type="text" class="edit-label-input" v-model="item.phyllum" ref="phyllum">
      <v-select :appendToBody="true" :options="list" v-model="item.kingdom_id" label="kingdom" index="kingdom_id"
        :reduce="r => r.kingdom_id" :clearable="false" style="min-width: 150px;">
        <template v-slot:selected-option="option">
          {{ `${option.kingdom}` }}
        </template>
        <template v-slot:option="option">
          {{ `${option.kingdom}` }}
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
          </template>
        </template>
      </v-select>
      <ul class="acoes d-flex justify-content-end">
        <li><a @click="salve"><span class="salvar mt-1"></span></a></li>
        <li><a @click="cancel"><span class="cancelar mt-1"></span></a></li>
      </ul>
  </span>
</template>

<script>
export default {
  name: 'EditTaxonomyPhyllum',
  props: {
    objPhyllum: {},
    list: Array
  },
  data: function () {
    return {
      item: {
        phyllum_id: 0,
        phyllum: ''
      }
    }
  },
  methods: {
    cancel: function () {
      this.$emit('cancelEdit')
    },
    salve: function () {
      this.$emit('salveEdit', this.item)
    }
  },
  mounted () {
    this.item = this.objPhyllum
    this.$refs.phyllum.focus()
  }
}
</script>
